// Aplica o tema do tenant via CSS variables no :root.
import type { Theme } from "../api.ts";

export function applyTheme(theme: Theme | null | undefined) {
  const root = document.documentElement;
  if (!theme) {
    root.style.removeProperty("--color-primary");
    root.style.removeProperty("--color-accent");
    root.style.removeProperty("--logo-url");
    return;
  }
  root.style.setProperty("--color-primary", theme.primary || "#0f172a");
  root.style.setProperty("--color-accent",  theme.accent  || "#facc15");
  root.style.setProperty(
    "--logo-url",
    theme.logoUrl ? `url("${theme.logoUrl}")` : "none",
  );
}
